export const enum PageAction {
  DownloadQrImage = 'DownloadQrImage',
  DownloadReservation = 'DownloadReservation',
  PaymentRetry = 'PaymentRetry',
}
